import React, { useMemo, useState } from 'react';
import UserContext from './UserContext';
import ContextUser from '../../types/ContextUser';

interface UserProviderProps {
  children: React.ReactNode;
}

function UserProvider({ children }: UserProviderProps): React.ReactElement {
  const [user, setUser] = useState<ContextUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const value = useMemo(
    () => ({
      user,
      setUser,
      isLoading,
      setIsLoading
    }),
    [user, setUser, isLoading, setIsLoading]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export default UserProvider;
